export default class Loan {
  id = 0;
  name = null;
  listingPrice= 300000;
  loanAmount = 0;
  downPaymentAmount = 0;
  downPaymentPercent = 5 + Math.round(Math.random()*20);
  rate = 3+Number(Math.random().toFixed(2));
  pmi = 50 + Math.round(Math.random()*100);
  term = 30;
  closingCost = 9000;
  monthlyPayment = 0;

  balanceArray = [];
  principalPaidArray = [];
  principalPerMonth = [];
  interestPaidArray = [];
  interestPerMonth = [];
  pmiPaidMonthlyArray = [];

  balanceYearlyArray = [];
  principalPaidYearlyArray = [];
  principalPerYear = [];
  interestPaidYearlyArray = [];
  interestPerYear = [];
  pmiPaidYearlyArray = [];

  originalInterest = 0;
  extraPerMonth = 0;
  payoffMonth = 0;
  pmiCutoffMonth = 0

  constructor(id, name, listingPrice)
  {
    this.id = id;
    this.name = name;
    this.listingPrice = listingPrice;
    this.closingCost = (0.03+Number((Math.random()*0.03).toFixed(2))) * listingPrice;
  }

  // getPaymentEachMonth()
  // {
  //   var costEachMonth = [];
  //   for(var i = 0; i < this.principalPaidArray.length; i++){
  //     costEachMonth.push(
  //         this.principalPaidArray[i]
  //         +this.interestPaidArray.length>i?this.interestPaidArray[i]:0
  //         +this.pmiPaidMonthlyArray.length>i?this.pmiPaidMonthlyArray[i]:0
  //         + this.closingCost
  //     );
  //   }
  //   console.log(costEachMonth)
  //   return costEachMonth;
  // }
}